import { Entry, BaseModel, Form, Resource, EntryTypes, CardMode, TableButton } from '@ngx-resource-toolkit/core';
import { environment } from '../../../../environments/environment';
import { LeaResource } from '../../resource/lea.resource';

@Resource({
    modes: {
        'default': {
            url: environment.proxyUrl + '/reference',
            methods: LeaResource.methods,
        }
    }
})

@Form({

})

export class ReferenceObjectModel extends BaseModel {
    constructor(data?) {
        super();
        if (!data) data = {};

        Object.assign(this, data);
    }
    
    @Entry({
        base: {
            hidden: true
        },
    })
    _explicitType: string = 'ReferenceObject';

    @Entry({
        base: {
            hidden: true
        },
    })
    id: number;

    @Entry({

    })
    libelle: string;

/*		public var valeur:Number;
		public var valeurStr:String;
		public var isActivated:Boolean;
		public var ordre:Number;
		public var isComplet:Boolean;
		public var isDeleted:Boolean;
		public var isModified:Boolean; //Indique si l'objet a été modifié
		public var anneeDebut:Number;
		public var anneeFin:Number;
        public var filtre:String;
*/
}


// WEBPACK FOOTER //
// /builds/eveasoft/lea/lea-front/src/app/shared/reference/models/reference-object.model.ts